"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var react_transition_group_1 = require("react-transition-group");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var winnerCard_1 = __importDefault(require("./winnerCard"));
var LastWinners = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder, hasDemo = _a.hasDemo, hasIcon = _a.hasIcon;
    var t = (0, next_intl_1.useTranslations)();
    var data = (0, swr_hooks_1.useLastWinnersFlexInterval)().data;
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return null;
    return (react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: styles_module_scss_1.default.lastWinnersWrapper }, data === null || data === void 0 ? void 0 : data.map(function (winner, idx) {
        var winnerName = (winner === null || winner === void 0 ? void 0 : winner.nickname) || t('common.anonymous');
        var key = "".concat(winner.gameTitle).concat(idx);
        return (
        // eslint-disable-next-line react/jsx-key
        react_1.default.createElement(winnerCard_1.default, { idx: idx, slug: winner === null || winner === void 0 ? void 0 : winner.slug, 
            // key={key}
            renderKey: key, title: (winner === null || winner === void 0 ? void 0 : winner.gameTitle) || '', playerName: winnerName, hasDemo: hasDemo, hasIcon: hasIcon, winInGame: "".concat(t('translation.in'), " ").concat((winner === null || winner === void 0 ? void 0 : winner.gameTitle) || ''), imageUrl: (0, apps_shared_1.getGameImageURL)(winner === null || winner === void 0 ? void 0 : winner.gameId) || '', prize: "".concat(winner.winAmount, " ").concat(winner.currency), gameId: winner === null || winner === void 0 ? void 0 : winner.gameId, gameCardPlaceholder: gameCardPlaceholder, isCurrent: !!(winner === null || winner === void 0 ? void 0 : winner.me) }));
    })));
};
exports.default = react_1.default.memo(LastWinners);
